import api from "./apiService";

export const getColleges = () => api().get(`/collegeMaster/`).then(response => response);

const services =  {
    getColleges
}


export default services;